import React from 'react';
import { useTranslation } from 'react-i18next';

// One blur for every withheld number (strip and modal): fake text hidden from assistive tech, one spoken label.
const LockedBlur = ({ children }) => {
  const { t } = useTranslation();
  return (
    <span className="relative inline-block">
      <span aria-hidden="true" className="select-none blur-[5px]">{children}</span>
      <span className="sr-only">{t('map.scorecards.lockedCell', 'Locked, Elite plan')}</span>
    </span>
  );
};

export default LockedBlur;
